<template>
<v-layout>
    <v-flex xs12>
    <ServerIterator 
      v-if="reset"
      :items="items" 
      title="Tutorials" 
      :displayItem="displayComponent" 

      :total='total'
      :currentPage.sync="currentPage"
      >
      <template v-slot:topbar>
        <v-toolbar id="topbar"   dense>
          <v-toolbar-title>Workflows</v-toolbar-title>
          <v-spacer></v-spacer>
          <div style="padding-right: 10px;">{{category}}</div>
          <v-menu  v-if="categories != null && categories.length > 1" offset-y>
            <template v-slot:activator="{on, attrs}" :close-on-click="closeOnClick">
              <v-icon class="msg-icon" v-bind="attrs" v-on="on">mdi-sort</v-icon>
            </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in categories"
                  :key="index"
                >
                  <v-list-item-title @click="setCategory(item)">{{item}}</v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>
        </v-toolbar>
      </template>
    </ServerIterator>
    </v-flex>
  </v-layout>
  <!-- <Iterator :items="docs" title="Tutorials" :displayItem="displayComponent" height=300 /> -->
</template>

<script>
import axiosInstances from "@/../../coreui/server/axiosInstances"
import { sync } from 'vuex-pathify'
import ServerIterator from '@/../../coreui/components/ServerIterator'
import itemDisplay from './DisplayItem'
export default {
  components: {
    ServerIterator,
    itemDisplay
  },
  data() {
    return {
      reset: true,
      currentPage: {page: 1, items: 0},
      // docs: [],
      displayComponent: itemDisplay,
      items: [],
      total: 0,
      categories: ['All'],
      category: 'All'
    };
  },
  computed: {
    user: sync('login/loggedinUser')
  },
  watch: {
    currentPage: {
      deep: true,
      async handler (val) {
        await this.getItems((val.page - 1) * val.items, val.items)
      }
    },
    category: {
      immediate: true,
      async handler (val) {
        await this.getItems((this.currentPage.page - 1) * this.currentPage.items, this.currentPage.items)
      }
    }
  },
  methods: {
    setCategory(category) {
      this.category = category
    },
    async getCategories() {
      let cats = await axiosInstances.loginServer.get('/dt/v1/auth_doc?return=cat')
      this.categories = cats.data.map((i) => {return i.cat})
      this.categories = ['All', ...new Set(this.categories)]
    },
    async getItems(skip, limit) {
      // get items from the server
      let res
      this.items = []
      if (this.category == 'All') {
        res = await axiosInstances.loginServer.get("/dt/v1/paged/auth_doc?total")
        this.total = res.data.totalCount
      } else {
        res = await axiosInstances.loginServer.get("/dt/v1/auth_doc?cat="+this.category)
        if (res != null & res.data != null) {
          this.total = res.data.length
        } else {
          this.total = 0
        }
      }
      let url = "/dt/v1/paged/auth_doc?type=tutorial&skip="+
        skip + '&first=' + limit
      if (this.category != 'All') {
        url = url + '&cat=' + this.category
      }
      res = await axiosInstances.loginServer.get(url)
      if (res != null && res.data != null) {
        this.items = res.data
      }
    },
  },
  created() {
    this.getCategories();
    this.getItems();
  },
  mounted() {
  },
};
</script>
<style >
</style>